// Function to change anchor links

function updateLinks(selector) {
    const links = document.querySelectorAll(selector);
    links.forEach(link => {
        if (link.href.includes('https://www.pillowtalk.co.uk/collections')) {
            const paramString = 'sort_by=manual&filter.v.availability=1';
            if (link.href.includes('?')) {
                link.href += `&${paramString}`;
            } else {
                link.href += `?${paramString}`;
            }
        }
    });
}

// Update Header Nav Links of Collections
updateLinks('nav[aria-label="Primary"] a');

// Update Collection List Links of Collections
updateLinks('.cc-collection-list a');